<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'ReeditLocalClipTemplate',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'templateCode',
        placeholder: '模板编码',
        type: 'input'
      }, {
        name: 'templateName',
        placeholder: '模板名称',
        type: 'input'
      }, {
        name: 'status',
        placeholder: '状态',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '启用',
        }, {
          key: 0,
          value: '停用',
        }]
      }],
      permission: {
        add: 'reeditLocalClipTemplate:add',
        update: 'reeditLocalClipTemplate:update',
        delete: 'reeditLocalClipTemplate:delete',
        deleteBatch: 'reeditLocalClipTemplate:deleteBatch'
      },
      url: {
        get: '/reeditLocalClipTemplate/listByCondition',
        add: '/reeditLocalClipTemplate/add',
        update: '/reeditLocalClipTemplate/update',
        delete: '/reeditLocalClipTemplate/delete',
        delete_batch: '/reeditLocalClipTemplate/deleteBatch',
        status: '/reeditLocalClipTemplate/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '80',
      }, {
        field: 'templateCode',
        label: '模板编码',
        sort: false,
        show: true,
      }, {
        field: 'templateName',
        label: '模板名称',
        sort: false,
        show: true,
      }, {
        field: 'templateVersion',
        label: '版本',
        sort: false,
        show: true,
        width: '100',
      }, {
        field: 'scene',
        label: '适用场景',
        sort: false,
        show: true,
        width: '120',
      }, {
        field: 'description',
        label: '模板描述',
        sort: false,
        show: true,
      }, {
        field: 'demo',
        label: '示例说明',
        sort: false,
        show: true,
      }, {
        field: 'engineKey',
        label: '引擎Key',
        sort: false,
        show: true,
        width: '120',
      }, {
        field: 'sortOrder',
        label: '排序',
        sort: false,
        show: true,
        width: '80',
      }, {
        field: 'status',
        label: '状态',
        width: '90',
        status: true,
        sort: false,
        show: true,
      }, {
        field: 'remark',
        label: '备注',
        sort: false,
        show: true,
      }, {
        field: 'createTime',
        label: '创建时间',
        show: true,
        width: '160',
      }],
      formFields: {
        addTitle: '添加本地剪辑模板',
        updateTitle: '修改本地剪辑模板',
        model: [
          {
            field: 'id',
            label: 'ID',
            type: 'input',
            add: false,
            update: true
          },
          {
            field: 'templateCode',
            label: '模板编码',
            type: 'input',
            placeholder: '请输入模板唯一编码，如 three_image_dedup',
            rules: [
              {required: true, message: '模板唯一编码不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
          {
            field: 'templateName',
            label: '模板名称',
            type: 'input',
            placeholder: '请输入模板名称',
            rules: [
              {required: true, message: '模板名称不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
          {
            field: 'templateVersion',
            label: '模板版本',
            type: 'input',
            placeholder: '请输入版本，如 1.0.0',
            add: true,
            update: true,
          },
          {
            field: 'scene',
            label: '适用场景',
            type: 'input',
            placeholder: '请输入适用场景',
            add: true,
            update: true,
          },
          {
            field: 'description',
            label: '模板描述',
            type: 'textarea',
            placeholder: '请输入模板详细说明',
            add: true,
            update: true,
          },
          {
            field: 'demo',
            label: '示例说明',
            type: 'textarea',
            placeholder: '请输入示例说明',
            add: true,
            update: true,
          },
          {
            field: 'featuresJson',
            label: '标签JSON',
            type: 'textarea',
            placeholder: '如 ["自动去重","节奏加速"]',
            add: true,
            update: true,
          },
          {
            field: 'engineKey',
            label: '引擎Key',
            type: 'input',
            placeholder: 'Python/FFmpeg管线标识',
            rules: [
              {required: true, message: '引擎Key不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
          {
            field: 'sortOrder',
            label: '排序值',
            type: 'input',
            placeholder: '输入数字，越小越靠前',
            add: true,
            update: true,
          },
          {
            field: 'remark',
            label: '备注说明',
            type: 'textarea',
            placeholder: '请输入备注',
            add: true,
            update: true,
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
</style>
